const Cover = ({ src, alt }) => (
  <img
    style={{
      // aspectRatio: 16 / 9,
      borderRadius: '8px',
      width: '100%',
    }}
    src={src}
    alt={alt}
  />
)

export default Cover